import { Suspense, lazy } from "react";

import { Layout } from "../../features/layout";

const Content = lazy(() => import("./NotFoundContent"));

export function NotFoundPage() {
  return (
    <Layout>
      <Suspense fallback={<div>Loading...</div>}>
        <Content />
      </Suspense>
    </Layout>
  );
}
